import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patchnotes',
  templateUrl: './patchnotes.component.html',
  styleUrls: ['./patchnotes.component.css']
})
export class PatchnotesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
